/* eslint-disable no-constructor-return */
class EventBus {
  constructor() {
    if (!EventBus.instance) {
      this.listeners = {};
      EventBus.instance = this;
    }
    return EventBus.instance;
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    return () => {
      this.listeners[event] = this.listeners[event].filter((listener) => {
        return listener !== callback;
      });
    };
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => {
        return callback(data);
      });
    }
  }
}

const eventBus = new EventBus();
export default eventBus;
